
export default {
  path: '/abnormalNoNetwork',
  name: 'abnormalNoNetwork',
  component: () => import('./index.vue'),
  meta: {
    name: '暂无网络'
  }
};
